"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletTypes = exports.WalletType = void 0;
var WalletType;
(function (WalletType) {
    WalletType["None"] = "none";
    WalletType["Customer"] = "customer";
    WalletType["Stageclip"] = "stageclip";
})(WalletType = exports.WalletType || (exports.WalletType = {}));
exports.walletTypes = Object.keys(WalletType).map(key => WalletType[key]);
//# sourceMappingURL=nft-wallet-type.js.map